import Input from "../components/input/Input";
import * as Yup from "yup";
import Button from "../components/button/Button";
import { Formik, Form } from "formik";
import Link from "../components/Link/Link";
import Paragraph from "../components/paragraph/Paragraph";
import { ReactComponent as LoginIlustration } from "../assets/images/login-ilustration.svg";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { getAuthRoute, ROUTES } from "../constants/routes";
import { useRequestPasswordReset } from "../hooks/useRequestPasswordReset";

const validationSchema = Yup.object({
  email: Yup.string()
    .email("Email adresa nije ispravna")
    .required("Obavezno polje"),
});

const ForgotPassword = () => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1200px)" });
  const navigate = useNavigate();
  const { mutate, isLoading } = useRequestPasswordReset();

  return (
    <div className="auth forgot-password">
      <div className="auth_layout">
        <div className="auth_content">
          <header className="auth_header">
            <h1>Zaboravili ste lozinku?</h1>
            <Paragraph variant="p2">
              Unesite email i poslaćemo vam uputstvo za reset lozinke.
            </Paragraph>
          </header>

          <Formik
            onSubmit={(values, actions) => {
              mutate(
                { email: values.email },
                {
                  onSuccess: () => {
                    navigate(ROUTES.forgotPasswordSuccess, {
                      state: { email: values.email },
                    });
                  },
                  onError: (response) => {
                    actions.setFieldError(
                      "email",
                      // @ts-ignore
                      response?.response?.data?.message ||
                        "Došlo je do greške. Pokušajte ponovo."
                    );
                  },
                }
              );
            }}
            validationSchema={validationSchema}
            validateOnChange={false}
            initialValues={{ email: "" }}
          >
            <Form className="auth_form">
              <Input
                name="email"
                label="Email"
                placeholder="npr. ime@email.com"
                type="email"
                autoFocus
                autoComplete="email"
              />

              <Button
                variant="primary"
                label="Pošalji uputstvo"
                type="submit"
                hasLoader
                isLoading={isLoading}
                disabled={isLoading}
              />
            </Form>
          </Formik>

          <div className="auth_form-meta auth_form-meta--footer">
            <Link
              variant="secondary"
              label="Nazad na prijavu"
              onClick={() => navigate(getAuthRoute("login"))}
            />
          </div>
        </div>

        {isDesktop && (
          <LoginIlustration className="hover-float auth_illustration" />
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
